import React from "react";
import styled, { createGlobalStyle, keyframes } from "styled-components";
import ActionBar from "../common/ActionBar";

const Mis = () => {
  const [loading, setLoading] = React.useState(true);

  const baseUrl = process.env.REACT_APP_USER_BASE_URL || "";

  const domain_access = baseUrl.includes("//")
    ? baseUrl.split("//")[1]?.split(".")[0]
    : "https://user.iamch.org.in";

  const iframeSrc = `https://mis.justact.co.in/ss_login?next=/dashboard/list&portal=${domain_access}`;

  return (
    <>
      <GlobalStyle />
      <PageShell>
        <ActionBar breadcrumbs={["MIS Dashboard"]} />
        <FrameWrapper>
          <LoadingOverlay $visible={loading}>
            <Spinner />
            <LoadText>Connecting to dashboard…</LoadText>
          </LoadingOverlay>

          <Frame
            key={loading ? "reload" : "stable"}
            src={iframeSrc}
            title="MIS Iframe"
            onLoad={() => setLoading(false)}
            onError={() => setLoading(false)}
          />
        </FrameWrapper>
      </PageShell>
    </>
  );
};

export default Mis;

const GlobalStyle = createGlobalStyle`
  html, body, #root {
    height: 100%;
    overflow: hidden;
  }
  * {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  *::-webkit-scrollbar {
    display: none;
  }
`;

const shimmer = keyframes`
  0%   { background-position: -200% 0; }
  100% { background-position:  200% 0; }
`;

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const PageShell = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 74px);
  overflow: hidden;
  padding: 0;
  background: #f4f6fb;
  animation: ${fadeUp} 0.4s ease both;
`;

const FrameWrapper = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
  margin: 16px 20px 20px;
  border-radius: 12px;
  border: 1px solid #e1e3ee;
  background: #ffffff;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.06),
    0 8px 32px rgba(0, 0, 0, 0.08);
`;

const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: #ffffff;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  border-radius: 12px;
  opacity: ${(p) => (p.$visible ? 1 : 0)};
  pointer-events: ${(p) => (p.$visible ? "all" : "none")};
  transition: opacity 0.3s ease;
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 3px solid #e0e7ff;
  border-top-color: #00838c;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const LoadText = styled.p`
  font-size: 13px;
  letter-spacing: 0.4px;
  font-family: "DM Sans", "Segoe UI", sans-serif;
  background: linear-gradient(90deg, #94a3b8 25%, #00838c 50%, #94a3b8 75%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ${shimmer} 2s linear infinite;
`;

const Frame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 12px;
  display: block;
`;
